/**
 * Pronto Wishlist — localStorage only (no backend, no app)
 * Adds heart toggle to every product card + PDP.
 * Saved items page: /pages/wishlist (must exist as a Shopify page).
 * Sync across tabs in same browser via storage event.
 */
(function () {
  'use strict';
  var KEY = 'pronto:wishlist:v1';
  var ACCENT = '#dc2626';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 200))); } catch (e) {}
    window.dispatchEvent(new CustomEvent('pronto:wishlist:change', { detail: { count: arr.length } }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function add(item) {
    var arr = read();
    if (!arr.some(function (i) { return i.handle === item.handle; })) {
      arr.unshift(item);
      write(arr);
    }
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function toggle(item) {
    if (has(item.handle)) { remove(item.handle); return false; }
    add(item); return true;
  }

  /* === Render heart icon on every product card === */
  var HEART_OUTLINE = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var HEART_FILLED = '<svg viewBox="0 0 24 24" width="22" height="22" fill="' + ACCENT + '" stroke="' + ACCENT + '" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function buildButton(item) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pronto-wishlist-btn';
    btn.setAttribute('aria-label', 'Save to wishlist');
    btn.dataset.wishlistHandle = item.handle;
    var active = has(item.handle);
    btn.dataset.active = active ? '1' : '0';
    btn.innerHTML = active ? HEART_FILLED : HEART_OUTLINE;
    btn.style.cssText = [
      'position:absolute', 'top:10px', 'right:10px', 'z-index:5',
      'width:36px', 'height:36px', 'border-radius:50%', 'border:0',
      'background:rgba(255,255,255,0.9)', 'cursor:pointer', 'padding:0',
      'display:inline-flex', 'align-items:center', 'justify-content:center',
      'box-shadow:0 1px 6px rgba(0,0,0,0.08)', 'transition:transform 0.18s, background 0.18s'
    ].join(';');
    btn.addEventListener('mouseenter', function () { btn.style.transform = 'scale(1.08)'; });
    btn.addEventListener('mouseleave', function () { btn.style.transform = 'scale(1)'; });
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var nowActive = toggle(item);
      btn.innerHTML = nowActive ? HEART_FILLED : HEART_OUTLINE;
      btn.dataset.active = nowActive ? '1' : '0';
    });
    return btn;
  }

  function injectIntoCards(root) {
    var scope = root || document;
    scope.querySelectorAll('product-card-link, product-card, .product-card, .pronto-card').forEach(function (card) {
      if (card.dataset.prontoWishlistInit) return;
      var pid = card.dataset.productId || card.getAttribute('data-product-id');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var handle = (href.match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return;
      var titleEl = card.querySelector('[class*="title"], .product-title, .product-card__title, h2, h3');
      var imgEl = card.querySelector('img');
      var priceEl = card.querySelector('[class*="price"], .product-price, .product-card__price');
      var item = {
        handle: handle,
        title: titleEl ? titleEl.textContent.trim().slice(0, 120) : '',
        image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
        price: priceEl ? priceEl.textContent.trim().slice(0, 40) : '',
        url: href.startsWith('/') ? href : ('/products/' + handle),
        addedAt: Date.now()
      };
      /* Attach the heart on the gallery wrapper if possible (so heart sits on top of the image) */
      var gallery = card.querySelector('.card-gallery, .product-card__gallery, .product-card-img') || card;
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      gallery.appendChild(buildButton(item));
      card.dataset.prontoWishlistInit = '1';
    });
  }

  /* === Heart on PDP (next to the price or under the title) === */
  function injectOnPDP() {
    if (!/template-product/.test(document.body.className)) return;
    var titleEl = document.querySelector('.product-title, .product-info h1, h1.product__title') || document.querySelector('h1');
    if (!titleEl || titleEl.parentNode.querySelector('.pronto-wishlist-pdp')) return;
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    var imgEl = document.querySelector('.product-media img, .product__media img');
    var priceEl = document.querySelector('product-price, .product-price, .price');
    var item = {
      handle: handle,
      title: titleEl.textContent.trim().slice(0, 120),
      image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
      price: priceEl ? priceEl.textContent.trim().slice(0, 40) : '',
      url: '/products/' + handle,
      addedAt: Date.now()
    };
    var btn = buildButton(item);
    btn.classList.add('pronto-wishlist-pdp');
    btn.style.position = 'relative';
    btn.style.top = '';
    btn.style.right = '';
    btn.style.background = 'transparent';
    btn.style.boxShadow = 'none';
    btn.style.marginInlineStart = '8px';
    btn.style.verticalAlign = 'middle';
    var wrapper = document.createElement('span');
    wrapper.style.cssText = 'display:inline-flex;align-items:center;margin-left:12px;vertical-align:middle';
    wrapper.appendChild(btn);
    titleEl.appendChild(wrapper);
  }

  /* === Header counter badge === */
  function updateHeaderBadge() {
    var n = read().length;
    document.querySelectorAll('.pronto-wishlist-count').forEach(function (el) {
      el.textContent = String(n);
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  /* === Cross-tab sync via storage event === */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    /* Re-render all heart buttons */
    document.querySelectorAll('.pronto-wishlist-btn').forEach(function (btn) {
      var active = has(btn.dataset.wishlistHandle);
      btn.dataset.active = active ? '1' : '0';
      btn.innerHTML = active ? HEART_FILLED : HEART_OUTLINE;
    });
    updateHeaderBadge();
  });
  window.addEventListener('pronto:wishlist:change', updateHeaderBadge);

  /* === Mutation observer to catch dynamically added cards (filter, pagination) === */
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        injectIntoCards();
        break;
      }
    }
  });

  function init() {
    injectIntoCards();
    injectOnPDP();
    updateHeaderBadge();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* === Public API — used by /pages/wishlist template === */
  window.ProntoWishlist = {
    read: read,
    remove: remove,
    clear: function () { write([]); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
